import { jsx } from "react/jsx-runtime";
import SimCardDownloadIcon from "@mui/icons-material/SimCardDownload";
import { validateTidalLicense } from "../../base/index.js";
function SimCardDownload(props) {
  return /* @__PURE__ */ jsx(
    SimCardDownloadIcon,
    {
      "data-testid": "SimCardDownload",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "SimCardDownload",
      "data-tidal-icon-meta": "fileActions"
    }
  );
}
SimCardDownload.tidalIconMeta = {
  categories: "fileActions",
  name: "SimCardDownload"
};
validateTidalLicense();
export {
  SimCardDownload
};
//# sourceMappingURL=SimCardDownload.js.map
